<template lang="pug">
  v-container
    template(v-if="loading")
    v-row(v-else)
      v-col(cols="12")
        h1 {{ instruction.name }}
      v-col(cols="12")
        div(v-html="instruction.content")
</template>
<script>
import directoryService from '@/services/API/_directory';

export default {
  data() {
    return {
      loading:false,
      instruction: null,
    };
  },
  created() {
    this.init();
  },
  methods:{
    async init() {
      await this.fetchInstruction();
    },
    async fetchInstruction() {
      // console.log(this.$route);
      if (this.$route.query.pfdo) {
        const response = await directoryService.showHelp(this.$route.params.id);
        this.instruction = { ...response.data.data, content: response.data.data.body };
        document.title = String(this.instruction.name);
      } else {
        const response = await directoryService.showServiceHelp(this.$route.params.id);
        this.instruction = response.data.data;
      }
    },
  },
};
</script>

<style>
img {
  max-width: 100%;
  object-fit: contain;
}
</style>
